import React from 'react';

import { Dxf } from '../../../../../../viewer/elements/dxf';
import { Glb } from '../../../../../../viewer/elements/glb';
import { DxfFactory } from '../../../../../../viewer/loader/dxf/dxf-factory';
import { useNonce } from '../../../../../hooks/use-nonce';
import { useSharedView } from '../../../../../hooks/use-shared-view';
import { useAsset } from '../../../hooks/use-asset';
import { Asset } from '../../components/asset-blocks/asset';
import { CadBody } from './cad-body';
import { CadHeader } from './cad-header';

type Props = {
  asset: Dxf | Glb;
};

const CadAsset = (props: Props) => {
  const [_, refresh] = useNonce();
  const { sharedViewId } = useSharedView();

  useAsset(props.asset, {
    onAssetChanged: refresh,
  });

  React.useEffect(() => {
    if (props.asset instanceof Dxf) {
      const dxfAsset = props.asset;
      dxfAsset.setParseCallback(async (versionId?: string, fileId?: string) => {
        // todo: Handle parse errors (result.err exist).
        const result = await DxfFactory.instance().parseDXFFile(
          props.asset.name,
          versionId,
          sharedViewId,
          fileId,
        );
        dxfAsset.setDXFData(result.dxf);
        props.asset.visible = true;
        refresh();
      });
    }

    return () => {
      if (props.asset instanceof Dxf) {
        props.asset.setParseCallback(undefined);
      }
    };
  }, [props.asset, refresh, sharedViewId]);

  return (
    <Asset asset={props.asset}>
      {{
        header: <CadHeader asset={props.asset} />,
        content: <CadBody asset={props.asset} refreshAsset={refresh} />,
      }}
    </Asset>
  );
};

export { CadAsset, Props as CadAssetProps };
